import { motion } from "framer-motion";

const StorySection = () => {
  return (
    <section id="story" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left: Text Content */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="order-2 lg:order-1"
          >
            <span className="font-montserrat text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-6 block">
              Notre Histoire
            </span>

            <h2 className="font-playfair text-4xl md:text-5xl font-medium tracking-tight text-[#1A1A1A] mb-8 leading-tight">
              Une Passion pour
              <br />
              <span className="italic font-cormorant">l'Excellence</span>
            </h2>

            <div className="space-y-6">
              <p className="font-montserrat text-base md:text-lg text-[#666] leading-relaxed">
                Depuis notre création, ParfumAlgérie s'est donné pour mission
                d'apporter les plus belles fragrances du monde à travers toute
                l'Algérie. Notre passion pour la parfumerie nous guide dans la
                sélection rigoureuse de chaque essence.
              </p>

              <p className="font-montserrat text-base md:text-lg text-[#666] leading-relaxed">
                Nous croyons que chaque parfum raconte une histoire, évoque des
                émotions et crée des souvenirs inoubliables. C'est pourquoi nous
                travaillons avec les meilleures maisons de parfumerie pour vous
                offrir une expérience olfactive exceptionnelle.
              </p>

              {/* Quote */}
              <blockquote className="border-l-2 border-[#D4AF37] pl-6 py-2 mt-8">
                <p className="font-cormorant text-2xl md:text-3xl italic text-[#1A1A1A] leading-snug">
                  "Le parfum est la forme la plus intense du souvenir."
                </p>
                <cite className="font-montserrat text-sm text-[#999] mt-4 block not-italic">
                  — Jean Paul Guerlain
                </cite>
              </blockquote>
            </div>

            {/* Key Points */}
            <div className="grid grid-cols-2 gap-6 mt-12 pt-8 border-t border-black/5">
              <div>
                <span className="font-playfair text-3xl text-[#D4AF37] block mb-2">
                  100%
                </span>
                <span className="font-montserrat text-sm text-[#666] uppercase tracking-wide">
                  Authenticité Garantie
                </span>
              </div>
              <div>
                <span className="font-playfair text-3xl text-[#D4AF37] block mb-2">
                  24h
                </span>
                <span className="font-montserrat text-sm text-[#666] uppercase tracking-wide">
                  Expédition Rapide
                </span>
              </div>
            </div>
          </motion.div>

          {/* Right: Image */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
            className="order-1 lg:order-2 relative"
          >
            <div className="relative">
              {/* Decorative background */}
              <div className="absolute -inset-4 bg-[#E0E5DF]/30 rounded-sm -z-10" />
              
              {/* Main Image */}
              <div className="relative aspect-[4/5] overflow-hidden rounded-sm">
                <img
                  src="https://images.pexels.com/photos/28606628/pexels-photo-28606628.jpeg"
                  alt="Notre histoire - Parfumerie de luxe"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
              </div>

              {/* Floating Element */}
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: 0.5, duration: 0.5 }}
                className="absolute -bottom-8 -right-8 bg-[#1A1A1A] text-white p-8 rounded-sm shadow-hover hidden md:block"
              >
                <span className="font-playfair text-4xl block mb-1">5+</span>
                <span className="font-montserrat text-xs uppercase tracking-[0.15em] text-white/70">
                  Années d'Excellence
                </span>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default StorySection;
